import { UserFeedbackFormCore } from './FormModel/UserFeedbackFormCore'

export enum ProblemTypeEnum {
  ReportProblem = 1,
  ProductSuggestion = 2
}

export enum ScenarioEnum {
  Account = 1,
  Transaction = 2,
  Balance = 3,
  Others = 4
}

export enum UserFeedbackCodeEnum {
  Type = 600,
  Scenario = 601,
  Description = 602,
  Attachment = 603,
  EmailCheckBox = 604
}

export const PROBLEM_TYPE_TEXT_MAP = {
  [ProblemTypeEnum.ReportProblem]: 'report_problem',
  [ProblemTypeEnum.ProductSuggestion]: 'product_suggestion'
}

export const SCENARIO_TEXT_MAP = {
  [ScenarioEnum.Account]: 'account',
  [ScenarioEnum.Transaction]: 'transaction',
  [ScenarioEnum.Balance]: 'balance',
  [ScenarioEnum.Others]: 'others'
}

export interface IFieldProps {
  formCore: UserFeedbackFormCore
  onClick: (value?: string | number) => void
}
